<template lang="pug">
  .empty-panel
    .flex-wrap
      .info-box
        .main-info Set up surveys and questionnaires for market research and customer feedback.
        .check-list
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading CONTENT BUILDER
              p Create your survey with an easy to use content builder.
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading SET A TARGET
              p Set a target for number of surveys to be completed by each user.
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading SCHEDULE BRIEFS
              p Schedule surveys with a start and end date so they can be seen at a specific time.
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading SEND TO GROUPS
              p Choose which groups you’d like to see the survey, or select specific users. 
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading DETAILED REPORTS
              p View detailed reports and analytics of all the surveys you send. 
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading NOTIFY USERS
              p Choose to notify your team by SMS or email when they recieve a new survey. 
        router-link(:to="{ name: 'insight:surveyCreate' }")
          .el-button.pink GET STARTED
      .img-box
        img(src='@/assets/images/emptystates/insight-phone.png')
        


</template>

<script>
export default {};
</script>

<style scoped lang="scss"></style>
